import { getReq } from './axios';
import { allDepositsParams, fundsBalanceParams } from './models';
var BASE_URL = "".concat(apiUrl, "/office-funds");
export var getAllOfficeFunds = function getAllOfficeFunds(params) {
  return getReq(BASE_URL, {
    params: allDepositsParams(params)
  });
};
export var getOfficeFunds = function getOfficeFunds(params) {
  return getReq("".concat(BASE_URL, "/get-balance"), {
    params: fundsBalanceParams(params)
  });
};